// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__vIgI3","col":"styles_col__623SC"};